import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './styleMenu';

function UsuariosMenu() {
  return (
    <Container>
      <Link to="/user/register" className="link">
        Cadastrar usuário
      </Link>
      <Link to="/user/list" className="link">
        Listar usuários
      </Link>
      <Link to="/group/user" className="link">
        Grupo Usuário
      </Link>
    </Container>
  );
}

export default UsuariosMenu;
